import { isValidDate } from "./is-valid-date";

export function isValidPeriod(period) {
  if (!period) return true;

  let [ from, to ] = period.split('-');

  return isValidDate(from) && isValidDate(to);
}
